import {
  CONFIRM_REGISTRATION_ERROR,
  CONFIRM_REGISTRATION_SUCCESS
} from '../constants/actionTypes';

const initState = {
  confirmSuccess: null,
  confirmedEmail: null,
  error: null,
  message: null,
  alreadyRegistered: null,
  joiningDetails: null
};

const confirmRegistration = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CONFIRM_REGISTRATION_SUCCESS:
      return {
        ...state,
        error: null,
        confirmSuccess: true,
        confirmedEmail: payload.confirmedEmail,
        alreadyRegistered: payload.alreadyRegistered,
        joiningDetails: payload.joiningDetails
      };

    case CONFIRM_REGISTRATION_ERROR:
      return {
        error: true,
        message: payload
      };

    default:
      return state;
  }
};

export default confirmRegistration;
